import { render, staticRenderFns } from "./TradeProductDetail.vue?vue&type=template&id=6b14a2d8&"
import script from "./TradeProductDetail.vue?vue&type=script&lang=js&"
export * from "./TradeProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeProductDetail.vue?vue&type=style&index=0&id=6b14a2d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports